
import { first } from 'rxjs/operators';
import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import * as VMasker from 'vanilla-masker';

@Directive({
    selector: '[TelefoneMask]',
})
export class TelefoneMaskDirective {

    constructor(
        public element: ElementRef,
        private control: NgControl,
    ) {
        this.control.valueChanges
            .pipe(first((value) => !!value ))
            .subscribe((s) => {
                this.control.control.setValue( this.formatValue(s) );
            });
    }

    @HostListener('input', ['$event'])
    public onEvent($event) {
        const valueToTransform = this.element.nativeElement.value;
        this.control.control.setValue( this.formatValue( valueToTransform ) );
    }

    private formatValue( value: string ) {
        return VMasker.toPattern( value, '(99) 9 9999-9999' );
    }

}
